// Firebase configuration
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';

const firebaseConfig = {
  apiKey: "AIzaSyD29z4QgkT_CvalsFrepgza51qUyPMXP9k",
  authDomain: "truevine-nursing.firebaseapp.com",
  projectId: "truevine-nursing",
  storageBucket: "truevine-nursing.firebasestorage.app",
  messagingSenderId: "592044865278",
  appId: "1:592044865278:web:d62c7dc3a80b25a4a357af"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Cloud Firestore
export const db = getFirestore(app);

// Initialize Cloud Functions
export const functions = getFunctions(app);

export default app;
